export const replaceHyphenAndConvertToLowerCase = (brandName: string) => {
  return brandName.toLowerCase().replaceAll('-', ' ')
}

export const replaceSpaceAndConvertToLowerCase = (brandName: string) => {
  return brandName.toLowerCase().replaceAll(' ', '-')
}
